<template>
  <div class="outbound-create">
    <h2>创建出库单</h2>
    <!-- 待实现创建出库单功能 -->
  </div>
</template>

<script>
export default {
  name: 'OutboundCreate'
}
</script> 